class MenuService {
  constructor(opts) {
    this.basePath = `${process.env.REACT_APP_API_URL}/menus`;
    if (localStorage.getItem('local') === 'true') {
      this.basePath = 'http://127.0.0.1:24000/menus';
    }

    const defaultHeaders = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-tabb-place': opts.place,
      Authorization: `Bearer ${opts.authToken}`,
    };

    this.opts = opts;
    this.opts.basePath = this.basePath;
    this.defaultHeaders = defaultHeaders;
  }

  async withStatusCode(result) {
    const data = await result.json();
    return { data, statusCode: result.status };
  }

  async get(path, opts = {}) {
    const res = await fetch(`${this.opts.basePath}${path}`, {
      headers: { ...this.defaultHeaders, ...opts.headers },
      method: 'GET',
    });

    return this.withStatusCode(res);
  }

  async post(path, body, opts = {}) {
    const res = await fetch(`${this.opts.basePath}${path}`, {
      headers: { ...this.defaultHeaders, ...opts.headers },
      method: 'POST',
      body: JSON.stringify(body),
    });

    return this.withStatusCode(res);
  }

  async delete(path, opts = {}) {
    const res = await fetch(`${this.opts.basePath}${path}`, {
      headers: { ...this.defaultHeaders, ...opts.headers },
      method: 'DELETE',
    });

    return this.withStatusCode(res);
  }

  async update(path, body, opts = {}) {
    const res = await fetch(`${this.opts.basePath}${path}`, {
      headers: { ...this.defaultHeaders, ...opts.headers },
      method: 'PATCH',
    });

    return this.withStatusCode(res);
  }
}

// MenuServiceFactory - returns configured network instance for the menu service
export function MenuServiceFactory(authToken, place) {
  const opts = {
    place,
    authToken,
  };
  return new MenuService(opts);
}

export default MenuService;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/services/network.js